// extracted by mini-css-extract-plugin
export var about = "about-module--about--3cd09";
export var about__arrow = "about-module--about__arrow--1631c";
export var about__arrowBlock = "about-module--about__arrow-block--f33d8";
export var about__arrowBtn = "about-module--about__arrow-btn--68cbc";
export var about__arrowContent = "about-module--about__arrow-content--7125f";
export var about__arrowContentLeft = "about-module--about__arrow-content--left--525bc";
export var about__arrowContentRight = "about-module--about__arrow-content--right--99e00";
export var about__arrowImg = "about-module--about__arrow-img--ba58f";
export var about__arrowText = "about-module--about__arrow-text--0d1a9";
export var about__btn = "about-module--about__btn--7e93d";
export var about__img = "about-module--about__img--93499";
export var about__imgBlock = "about-module--about__img-block--1235e";
export var about__imgCircle = "about-module--about__img-circle--588cd";
export var about__imgItem = "about-module--about__img-item--30e63";
export var about__imgItemTitle = "about-module--about__img-item-title--d9e3f";
export var about__imgItemWrap = "about-module--about__img-item-wrap--f1c2b";
export var about__imgItemWrapLeft = "about-module--about__img-item-wrap--left--86242";
export var about__imgItemWrapRight = "about-module--about__img-item-wrap--right--bd2a6";
export var about__text = "about-module--about__text--fcc46";
export var about__textBlock = "about-module--about__text-block--6aab3";
export var howTo = "about-module--how-to--5a22c";